import { render, staticRenderFns } from "./DefaultImage.vue?vue&type=template&id=1634bad4&scoped=true&lang=pug&"
import script from "./DefaultImage.vue?vue&type=script&lang=js&"
export * from "./DefaultImage.vue?vue&type=script&lang=js&"
import style0 from "./DefaultImage.vue?vue&type=style&index=0&id=1634bad4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1634bad4",
  null
  
)

export default component.exports